import { Strings } from '@app/constants';
import { ProfileCard } from '@app/components/card';
import { IAssets } from '../types';

interface Props {
  userData: IAssets;
}

export const AssetsDetails = ({ userData }: Props) => {
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const assetUser = `${userData?.users?.firstName} ${userData?.users?.lastName}`;
  const assetImage = userData?.image;
  const fields = [
    Strings.assets.assetUser,
    Strings.assets.assetName,
    Strings.assets.vendor,
    Strings.assets.model,
    Strings.assets.status,
  ];
  const data = [
    userData?.users?.firstName ? assetUser : 'NA',
    userData?.assetName === 'other' ? userData?.otherAssetName : userData?.assetName ?? 'NA',
    userData?.vendors?.name ?? 'NA',
    userData?.model || 'NA',
    userData?.status ?? 'NA',
  ];
  return (
    <ProfileCard
      fields={fields}
      data={data}
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      Src={assetImage ?? `${userData?.users?.firstName} ${userData?.users?.lastName}`}
      title={Strings.profile.assetsInformation}
    />
  );
};
